module.exports = __webpack_public_path__ + "img/messages.40b786e1.svg";